/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnonymousMeetdayStudent } from '../../models/anonymous-meetday-student';
import { MeetDayStudent } from '../../models/meet-day-student';

export interface CreateAnonymousMeetDayStudent$Params {
  meetDayId: string;
      body?: AnonymousMeetdayStudent
}

export function createAnonymousMeetDayStudent(http: HttpClient, rootUrl: string, params: CreateAnonymousMeetDayStudent$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDayStudent>> {
  const rb = new RequestBuilder(rootUrl, createAnonymousMeetDayStudent.PATH, 'post');
  if (params) {
    rb.path('meetDayId', params.meetDayId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MeetDayStudent>;
    })
  );
}

createAnonymousMeetDayStudent.PATH = '/meetday/{meetDayId}/student/anonymous';
